import React, { FC } from 'react';
import { Icon as ChakraUiIcon, Box } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProps, PowerTransforms } from './types';
import '../../../icons/library';

import type { IconName, IconLookup, IconPrefix } from '@fortawesome/fontawesome-svg-core';

// see FontAwesomeIconProps in react-fontawesome for all available FA props

export const Icon: FC<IconProps> = props => {
  const {
    alignSelf,
    className,
    color,
    colorScheme,
    flip,
    icon,
    iconName,
    prefix,
    size = '1x',
    spin,
    transform,
    // style props
    boxSize,
    fontSize,
    height,
    lineHeight = 'inherit',
    margin,
    minHeight,
    minWidth,
    padding,
    width,
  } = props;

  /**
   * DOM
   */
  const hasIcon = iconName || icon;

  if (!hasIcon) {
    return null;
  }

  const getTransform = (transform: string | PowerTransforms | undefined): PowerTransforms | string => {
    if (!transform) {
      return '';
    }
    if (typeof transform === 'string') {
      return transform;
    }
    return {
      ...transform,
      rotate: transform.rotate ?? 0,
      x: transform.x ?? 0,
      y: transform.y ?? 0,
    };
  };

  const iconProps = {
    className,
    flip,
    size,
    spin,
    transform: getTransform(transform),
  };

  const styleProps = {
    boxSize,
    width,
    minWidth,
    height,
    minHeight,
    margin,
    padding,
    fontSize,
    lineHeight,
    alignSelf,
  };

  if (icon) {
    return <ChakraUiIcon {...styleProps} color={colorScheme ? `icon-${colorScheme}` : color} as={icon}></ChakraUiIcon>;
  }

  const iconProp: [IconPrefix, IconName] | IconName | IconLookup = prefix
    ? [prefix, iconName as unknown as IconName]
    : (iconName as unknown as IconName);

  const ThirdPartyIcon = () => <FontAwesomeIcon icon={iconProp} {...iconProps} />;

  return (
    <Box as={'span'} display="inline-block" color={colorScheme ? `icon-${colorScheme}` : color} {...styleProps}>
      <ChakraUiIcon as={ThirdPartyIcon}></ChakraUiIcon>
    </Box>
  );
};
